const removeNonNumericCharacters = value => value.replace(/\D/g, '');
export { removeNonNumericCharacters as default };
